module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comment",
      toString: function () {
        return this.url;
      }
    }